export default __webpack_public_path__ + "static/media/Ballroll_00216.9c0ba9bb.png";